// extracted by mini-css-extract-plugin
export default {"photo":"selectPhoto_photo__9W6xr","selectedImg":"selectPhoto_selectedImg__bz3-y","label":"selectPhoto_label__XHGfT","delete":"selectPhoto_delete__OuSHL"};